import * as React from "react";
import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";

import { cn } from "../../lib/utils";
import { Button } from "../ui/button";
import { Calendar } from "../ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Label } from "../ui/label";

export const DatePickerInput = (props) => {
  const { description = "", label, value, onChange = () => {} } = props;
  // Initialize date from value (handle both epoch timestamp and Date object)
  const [date, setDate] = React.useState(
    value
      ? typeof value === "number"
        ? new Date(value)
        : new Date(value)
      : undefined
  );

  // Sync with parent value changes
  React.useEffect(() => {
    if (value) {
      const newDate =
        typeof value === "number" ? new Date(value) : new Date(value);
      setDate(newDate);
    } else {
      setDate(undefined);
    }
  }, [value]);

  const handleSelect = (newDate) => {
    setDate(newDate);
    // Convert to epoch timestamp (milliseconds) for API
    const epochValue = newDate ? newDate.getTime() : undefined;
    onChange({ target: { value: epochValue } });
  };

  return (
    <div className="space-y-2">
      {label ? <Label>{label}</Label> : null}
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant={"outline"}
            className={cn(
              "w-full justify-start text-left font-normal",
              !date && "text-muted-foreground"
            )}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {date ? format(date, "PPP") : <span>Pick a date</span>}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            mode="single"
            selected={date}
            onSelect={handleSelect}
            initialFocus
          />
        </PopoverContent>
      </Popover>
      {description ? (
        <p className="text-xs text-muted-foreground">{description}</p>
      ) : null}
    </div>
  );
};

export default DatePickerInput;
